var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThrillerStories = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 57,
  height: 56,
  fill: "none",
  viewBox: "0 0 56 57"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__a)",
  d: "M39.931 45.046 34.526 7.355a5.41 5.41 0 0 0-6.122-4.587L7.039 5.832a5.41 5.41 0 0 0-4.587 6.122l5.405 37.691a5.41 5.41 0 0 0 6.122 4.587l21.365-3.064a5.41 5.41 0 0 0 4.587-6.122Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__b)",
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "m40.921 44.904-5.405-37.69a6.41 6.41 0 0 0-7.254-5.436L6.897 4.842a6.41 6.41 0 0 0-5.434 7.254l5.404 37.691a6.41 6.41 0 0 0 7.254 5.435l21.365-3.064a6.41 6.41 0 0 0 5.435-7.254Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__c)",
  d: "M27.63 4.305 8.214 7.089a4.638 4.638 0 0 0-3.933 5.249l5.224 36.426a4.638 4.638 0 0 0 5.249 3.933l19.418-2.785a4.638 4.638 0 0 0 3.932-5.249L32.88 8.237a4.638 4.638 0 0 0-5.25-3.932Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__d)",
  d: "m5.459 32.92 2.398 16.726a5.41 5.41 0 0 0 6.123 4.586l21.365-3.063a5.41 5.41 0 0 0 4.586-6.123L37.533 28.32l-32.074 4.6Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__e)",
  d: "m26.94 51.325-4.851.696a1.657 1.657 0 0 1-.47-3.28l4.851-.696a1.657 1.657 0 0 1 .47 3.28Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__f)",
  d: "M28.404 2.768 15.621 4.601l6.94 48.4 12.783-1.833a5.41 5.41 0 0 0 4.587-6.122l-5.404-37.69a5.41 5.41 0 0 0-6.123-4.588Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__g)",
  d: "m31.473 9.9 4.48 31.24a4.523 4.523 0 0 1-3.836 5.12l-16.42 2.354a4.523 4.523 0 0 1-5.118-3.835l-4.48-31.24a4.523 4.523 0 0 1 3.835-5.12l2.743-.393a.835.835 0 0 1 .945.708.835.835 0 0 0 .945.708l7.628-1.094a.835.835 0 0 0 .707-.945.835.835 0 0 1 .708-.944l2.744-.394A4.523 4.523 0 0 1 31.473 9.9Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__h)",
  d: "m26.354 6.065-2.744.394a.835.835 0 0 0-.708.944.835.835 0 0 1-.707.945l-7.628 1.094a.835.835 0 0 1-.945-.708.835.835 0 0 0-.945-.708l-2.743.394a4.523 4.523 0 0 0-3.835 5.119L7.746 25.02l25.373-3.639L31.473 9.9a4.523 4.523 0 0 0-5.12-3.835Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__i)",
  d: "m17.634 9.002-3.067.44a.835.835 0 0 1-.945-.708.835.835 0 0 0-.945-.708l-2.743.394a4.523 4.523 0 0 0-3.835 5.119l4.48 31.24a4.523 4.523 0 0 0 5.119 3.834l7.463-1.07-5.527-38.541Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__j)",
  d: "m23.268 31.7-3.633 4.85 12.863 9.637a4.522 4.522 0 0 0 3.453-5.047l-1.582-11.033-11.1 1.592Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M38.414 13.244h-1.15l.16 1.14 2.688 19.06.12.86h6.176a8.035 8.035 0 0 0 8.035-8.035v-4.99a8.035 8.035 0 0 0-8.035-8.035h-7.994Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__k)",
  d: "M19.514 14.244h26.895a7.035 7.035 0 0 1 7.035 7.035v4.99a7.035 7.035 0 0 1-7.035 7.035H23.566a.27.27 0 0 0-.233.137c-.786 1.354-2.422 2.319-4.57 2.874-.267.069-.445-.262-.247-.452.803-.766 1.198-1.523 1.264-2.264a.269.269 0 0 0-.267-.295 7.035 7.035 0 0 1-7.035-7.035v-4.99a7.035 7.035 0 0 1 7.036-7.035Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__l)",
  d: "M53.444 21.279v4.99a7.035 7.035 0 0 1-7.035 7.035h-5.854v-19.06h5.854a7.035 7.035 0 0 1 7.035 7.035Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__m)",
  d: "M12.479 21.394v4.875a7.035 7.035 0 0 0 7.034 7.035c.159 0 .28.136.267.294-.067.742-.46 1.499-1.264 2.265-.198.19-.02.52.246.452 2.149-.555 3.785-1.52 4.571-2.874a.27.27 0 0 1 .233-.137H46.41a7.035 7.035 0 0 0 7.035-7.035v-4.875H12.477Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__n)",
  d: "m21.287 28.187 2.197.688a.918.918 0 0 0 1.192-.866l.025-2.302a.918.918 0 0 1 .17-.522l1.332-1.877a.918.918 0 0 0-.455-1.402l-2.181-.735a.918.918 0 0 1-.444-.322L21.75 19a.918.918 0 0 0-1.475 0l-1.373 1.848a.919.919 0 0 1-.444.322l-2.181.735a.918.918 0 0 0-.456 1.402l1.333 1.877a.92.92 0 0 1 .17.522l.025 2.302a.918.918 0 0 0 1.192.866l2.197-.688a.917.917 0 0 1 .549 0Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__o)",
  d: "M15.743 22.377a.915.915 0 0 0 .078.93l1.333 1.877a.919.919 0 0 1 .17.522l.024 2.302a.918.918 0 0 0 1.193.866l2.197-.688a.919.919 0 0 1 .549 0l2.197.688a.918.918 0 0 0 1.192-.866l.025-2.302c0-.09.015-.18.042-.264l-9-3.065Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__p)",
  d: "M26.282 22.377a.915.915 0 0 1-.078.93l-1.333 1.877a.92.92 0 0 0-.17.522l-.024 2.302a.918.918 0 0 1-1.193.866l-2.197-.688a.917.917 0 0 0-.549 0l-2.196.688a.918.918 0 0 1-1.193-.866l-.025-2.302a.913.913 0 0 0-.042-.264l9-3.065Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__q)",
  d: "m25.748 21.906-2.181-.735a.919.919 0 0 1-.444-.322L21.75 19a.913.913 0 0 0-.737-.37v9.514a.92.92 0 0 1 .274.042l2.197.688a.918.918 0 0 0 1.192-.866l.025-2.302a.918.918 0 0 1 .17-.522l1.333-1.877a.918.918 0 0 0-.456-1.402Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__r)",
  d: "m25.748 21.906-2.181-.735a.919.919 0 0 1-.444-.322L21.75 19a.913.913 0 0 0-.737-.37v9.514a.92.92 0 0 1 .274.042l2.197.688a.918.918 0 0 0 1.192-.866l.025-2.302a.918.918 0 0 1 .17-.522l1.333-1.877a.918.918 0 0 0-.456-1.402Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__s)",
  d: "M17.286 25.456c.024.08.037.165.038.25l.025 2.302a.918.918 0 0 0 1.192.866l2.197-.688a.917.917 0 0 1 .549 0l2.197.688a.918.918 0 0 0 1.192-.866l.025-2.302c.001-.085.014-.17.038-.25h-7.453Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__t)",
  d: "m21.17 26.313 1.263.395a.528.528 0 0 0 .687-.498l.014-1.325a.53.53 0 0 1 .097-.3l.767-1.08a.528.528 0 0 0-.262-.806l-1.255-.423a.528.528 0 0 1-.255-.185l-.79-1.063a.528.528 0 0 0-.848 0l-.79 1.063a.53.53 0 0 1-.255.185l-1.255.423a.528.528 0 0 0-.262.806l.766 1.08a.527.527 0 0 1 .098.3l.014 1.325a.528.528 0 0 0 .686.498l1.264-.395a.528.528 0 0 1 .316 0Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__u)",
  d: "m33.234 28.187 2.197.688a.918.918 0 0 0 1.193-.867l.024-2.302a.918.918 0 0 1 .17-.521l1.333-1.877a.918.918 0 0 0-.456-1.402l-2.181-.735a.917.917 0 0 1-.444-.322L33.697 19a.918.918 0 0 0-1.474 0l-1.373 1.848a.917.917 0 0 1-.444.322l-2.182.735a.918.918 0 0 0-.455 1.402l1.333 1.877a.919.919 0 0 1 .17.521l.024 2.302a.918.918 0 0 0 1.192.867l2.197-.688a.917.917 0 0 1 .55 0Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__v)",
  d: "M27.69 22.377a.915.915 0 0 0 .078.93l1.333 1.878a.919.919 0 0 1 .17.521l.025 2.302a.918.918 0 0 0 1.192.867l2.197-.688a.917.917 0 0 1 .549 0l2.197.688a.918.918 0 0 0 1.192-.867l.025-2.302a.916.916 0 0 1 .042-.264l-9-3.065Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__w)",
  d: "M38.23 22.377a.915.915 0 0 1-.079.93l-1.333 1.878a.919.919 0 0 0-.17.521l-.024 2.302a.918.918 0 0 1-1.193.867l-2.197-.688a.917.917 0 0 0-.548 0l-2.197.688a.918.918 0 0 1-1.193-.867l-.024-2.302c-.001-.09-.016-.179-.042-.264l9-3.065Z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__x)",
  d: "m37.696 21.906-2.182-.735a.918.918 0 0 1-.444-.322L33.697 19a.913.913 0 0 0-.737-.37v9.514c.093 0 .185.014.274.042l2.197.688a.918.918 0 0 0 1.193-.867l.024-2.301a.918.918 0 0 1 .17-.522l1.333-1.877a.918.918 0 0 0-.456-1.402Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__y)",
  d: "m37.696 21.906-2.182-.735a.918.918 0 0 1-.444-.322L33.697 19a.913.913 0 0 0-.737-.37v9.514c.093 0 .185.014.274.042l2.197.688a.918.918 0 0 0 1.193-.867l.024-2.301a.918.918 0 0 1 .17-.522l1.333-1.877a.918.918 0 0 0-.456-1.402Z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__z)",
  d: "M29.232 25.456c.024.081.038.165.038.25l.025 2.302a.918.918 0 0 0 1.193.867l2.197-.688a.919.919 0 0 1 .548 0l2.197.688a.918.918 0 0 0 1.193-.867l.024-2.302a.922.922 0 0 1 .038-.25h-7.453Z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__A)",
  d: "m33.117 26.313 1.264.396a.528.528 0 0 0 .686-.499l.014-1.324a.528.528 0 0 1 .098-.3l.766-1.08a.528.528 0 0 0-.262-.807l-1.255-.423a.528.528 0 0 1-.255-.185l-.79-1.063a.528.528 0 0 0-.848 0l-.79 1.063a.53.53 0 0 1-.255.185l-1.255.423a.528.528 0 0 0-.262.807l.767 1.08a.529.529 0 0 1 .097.3l.014 1.324a.528.528 0 0 0 .687.498l1.263-.395a.528.528 0 0 1 .316 0Z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__B)",
  d: "m45.183 28.187 2.197.688a.918.918 0 0 0 1.193-.867l.024-2.302a.918.918 0 0 1 .17-.521l1.333-1.877a.918.918 0 0 0-.456-1.402l-2.181-.735a.917.917 0 0 1-.444-.322L45.646 19a.918.918 0 0 0-1.474 0l-1.373 1.848a.917.917 0 0 1-.444.322l-2.182.735a.918.918 0 0 0-.455 1.402l1.333 1.877a.919.919 0 0 1 .17.521l.024 2.302a.918.918 0 0 0 1.193.867l2.197-.688a.917.917 0 0 1 .548 0Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__C)",
  d: "M39.64 22.377a.915.915 0 0 0 .078.93l1.333 1.878a.919.919 0 0 1 .17.521l.024 2.302a.918.918 0 0 0 1.193.867l2.196-.688a.919.919 0 0 1 .55 0l2.196.688a.918.918 0 0 0 1.192-.867l.025-2.302c.001-.09.016-.179.042-.264l-9-3.065Z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__D)",
  d: "M50.179 22.377a.915.915 0 0 1-.079.93l-1.333 1.878a.92.92 0 0 0-.17.521l-.024 2.302a.918.918 0 0 1-1.193.867l-2.196-.688a.919.919 0 0 0-.549 0l-2.197.688a.918.918 0 0 1-1.192-.867l-.025-2.302c-.001-.09-.016-.179-.042-.264l9-3.065Z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__E)",
  d: "m49.645 21.906-2.182-.735a.918.918 0 0 1-.444-.322L45.646 19a.912.912 0 0 0-.737-.37v9.514c.093 0 .185.014.275.042l2.196.688a.918.918 0 0 0 1.193-.867l.025-2.302a.919.919 0 0 1 .17-.521l1.332-1.877a.918.918 0 0 0-.455-1.402Z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__F)",
  d: "m49.645 21.906-2.182-.735a.918.918 0 0 1-.444-.322L45.646 19a.912.912 0 0 0-.737-.37v9.514c.093 0 .185.014.275.042l2.196.688a.918.918 0 0 0 1.193-.867l.025-2.302a.919.919 0 0 1 .17-.521l1.332-1.877a.918.918 0 0 0-.455-1.402Z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__G)",
  d: "M41.182 25.456c.023.081.037.165.038.25l.024 2.302a.918.918 0 0 0 1.193.867l2.197-.688a.919.919 0 0 1 .548 0l2.197.688a.918.918 0 0 0 1.193-.867l.025-2.302c0-.085.014-.169.038-.25h-7.453Z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#thriller-stories_svg__H)",
  d: "m45.066 26.313 1.264.396a.528.528 0 0 0 .686-.499l.014-1.324a.53.53 0 0 1 .098-.3l.767-1.08a.528.528 0 0 0-.262-.806l-1.255-.423a.528.528 0 0 1-.256-.186l-.79-1.063a.528.528 0 0 0-.848 0l-.79 1.063a.53.53 0 0 1-.255.186l-1.255.422a.528.528 0 0 0-.262.807l.767 1.08a.529.529 0 0 1 .097.3l.015 1.324a.528.528 0 0 0 .686.499l1.264-.396a.528.528 0 0 1 .315 0Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__a",
  x1: -0.482,
  x2: 38.677,
  y1: 23.521,
  y2: 32.517,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B55CFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__b",
  x1: -0.482,
  x2: 38.677,
  y1: 23.521,
  y2: 32.517,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B55CFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__c",
  x1: 40.59,
  x2: 3.873,
  y1: 26.855,
  y2: 29.97,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5200FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#854DFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__d",
  x1: 24.184,
  x2: 24.606,
  y1: 49.363,
  y2: 52.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__e",
  x1: 24.54,
  x2: 24.146,
  y1: 51.853,
  y2: 49.106,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9039FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__f",
  x1: 33.4,
  x2: 37.054,
  y1: 26.75,
  y2: 26.226,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__g",
  x1: 7.964,
  x2: 33.275,
  y1: 20.797,
  y2: 33.475,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5FBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8ECFE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__h",
  x1: 18.852,
  x2: 18.214,
  y1: 12.184,
  y2: 7.735,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3DAFE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.431,
  stopColor: "#B1D9FE",
  stopOpacity: 0.432
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.666,
  stopColor: "#A9D6FE",
  stopOpacity: 0.666
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.852,
  stopColor: "#9BD0FE",
  stopOpacity: 0.852
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__i",
  x1: 17.247,
  x2: 8.554,
  y1: 27.881,
  y2: 29.128,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3DAFE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.431,
  stopColor: "#B1D9FE",
  stopOpacity: 0.432
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.666,
  stopColor: "#A9D6FE",
  stopOpacity: 0.666
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.852,
  stopColor: "#9BD0FE",
  stopOpacity: 0.852
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__j",
  x1: 36.159,
  x2: 25.71,
  y1: 45.486,
  y2: 31.614,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3DAFE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.431,
  stopColor: "#B1D9FE",
  stopOpacity: 0.432
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.666,
  stopColor: "#A9D6FE",
  stopOpacity: 0.666
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.852,
  stopColor: "#9BD0FE",
  stopOpacity: 0.852
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__k",
  x1: 27.351,
  x2: 37.431,
  y1: 12.553,
  y2: 32.714,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA1AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__l",
  x1: 48.896,
  x2: 53.49,
  y1: 23.774,
  y2: 23.774,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.234,
  stopColor: "#7000FF",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.517,
  stopColor: "#7000FF",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.824,
  stopColor: "#7000FF",
  stopOpacity: 0.82
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__m",
  x1: 32.961,
  x2: 32.961,
  y1: 28.044,
  y2: 34.033,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.234,
  stopColor: "#7000FF",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.517,
  stopColor: "#7000FF",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.824,
  stopColor: "#7000FF",
  stopOpacity: 0.82
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__n",
  x1: 19.309,
  x2: 25.091,
  y1: 22.835,
  y2: 28.617,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__o",
  x1: 20.287,
  x2: 21.131,
  y1: 25.099,
  y2: 23.114,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__p",
  x1: 21.668,
  x2: 21.194,
  y1: 24.785,
  y2: 23.303,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__q",
  x1: 21.819,
  x2: 20.021,
  y1: 23.793,
  y2: 23.852,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__r",
  x1: 24.449,
  x2: 25.758,
  y1: 24.473,
  y2: 24.895,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__s",
  x1: 21.013,
  x2: 21.013,
  y1: 27.124,
  y2: 28.787,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__t",
  x1: 22.985,
  x2: 17.953,
  y1: 26.187,
  y2: 21.155,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__u",
  x1: 31.256,
  x2: 37.038,
  y1: 22.835,
  y2: 28.617,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__v",
  x1: 32.234,
  x2: 33.079,
  y1: 25.099,
  y2: 23.115,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__w",
  x1: 33.615,
  x2: 33.141,
  y1: 24.786,
  y2: 23.304,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__x",
  x1: 33.766,
  x2: 31.968,
  y1: 23.793,
  y2: 23.852,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__y",
  x1: 36.396,
  x2: 37.705,
  y1: 24.473,
  y2: 24.895,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__z",
  x1: 32.959,
  x2: 32.959,
  y1: 27.124,
  y2: 28.787,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__A",
  x1: 34.933,
  x2: 29.9,
  y1: 26.187,
  y2: 21.155,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__B",
  x1: 43.206,
  x2: 48.987,
  y1: 22.835,
  y2: 28.617,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__C",
  x1: 44.184,
  x2: 45.028,
  y1: 25.099,
  y2: 23.115,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__D",
  x1: 45.565,
  x2: 45.09,
  y1: 24.786,
  y2: 23.303,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__E",
  x1: 45.716,
  x2: 43.917,
  y1: 23.793,
  y2: 23.852,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__F",
  x1: 48.345,
  x2: 49.654,
  y1: 24.473,
  y2: 24.895,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__G",
  x1: 44.908,
  x2: 44.908,
  y1: 27.124,
  y2: 28.787,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "thriller-stories_svg__H",
  x1: 46.882,
  x2: 41.849,
  y1: 26.188,
  y2: 21.155,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})))));
export { SvgThrillerStories as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDlmNDkxMjg3OWYyOGUwNjkzNDk2YTk1YWUwZGE3YjAuc3ZnIjs=";